export default __webpack_public_path__ + "static/media/gkelite.6ccdb768.png";